import React, { PureComponent } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

class CompanyTabs extends PureComponent {
  render() {
    const {
      isAdmin,
      active,
      match: { params },
    } = this.props;

    const tabs = [
      {
        title: 'Ogólne',
        url: 'overall',
      },
      {
        title: 'Samochody',
        url: 'cars',
      },
      {
        title: 'Gwarancje',
        url: 'warranties',
      },
      {
        title: 'Użytkownicy',
        url: 'users',
      },
    ];

    const adminTab = {
      title: 'Awarie',
      url: 'breakdowns',
    };

    if (isAdmin) {
      tabs.push(adminTab);
    }

    return (
      <div className="row m-0 pt-3 pb-2">
        {tabs.map((item, index) => (
          <div className="card" key={index}>
            <div className="card-body">
              {item.url === active ? (
                <NavLink
                  className="breadcrumb-item active"
                  to={`/company-details/${params.id}/${item.url}`}
                >
                  {item.title}
                </NavLink>
              ) : (
                <NavLink to={`/company-details/${params.id}/${item.url}`}>
                  {item.title}
                </NavLink>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

CompanyTabs.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  active: PropTypes.string,
};

CompanyTabs.defaultProps = {
  active: 'overall',
};

export default withRouter(CompanyTabs);
